import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Award, DatabaseProduct } from "../../Api/Database";
import RegisterAward from "./registerAward";
import config from "../../Api/config";
import { useSession } from "../sessionProvider";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import RegisterImage from "./registerImage";

let serverUrl = window.location.origin;

type FormInputs = {
    file: FileList,
};

interface RegisterVariantProps {
    parent?: DatabaseProduct
}

function EditVariant(props: RegisterVariantProps) {

    const navigate = useNavigate();
    const notifyError = (err: any) => toast.error(err, { theme: "colored" });
    const notifySuccess = (text: any) => toast.success(text, { theme: "colored" });

    const { handleSubmit, formState: { errors } } = useForm<FormInputs>();
    const { ownerId } = useSession();
    const { variantId } = useParams();

    const [parentId, setParentId] = useState(props.parent)

    const [productData, setProductData] = useState({
        title: "",
        description: "",
        thumbnail: "",
        image_gallery: [] as string[],
        sap_product_code: "",
        shop_url: "",
    });

    const [userManualData, setUserManualData] = useState({
        "product_presentation": "",
        "video_presentation": "",
        "user_manual": "",
        "cleaning_instructions": ""
    });

    const [sustainabilityData, setSustainabilityData] = useState({
        "recycled_biobased_material_share": "",
        "energy_source_in_production": "",
        "recyclability": "",
        "compliance_with_standards": "",
        "carbon_footprint": "",
        "carbon_footprint_reduction_renewables": ""
    });

    const [awards, setAwards] = useState<Award[]>([]);
    const [pictures, setPictures] = useState<any[]>([]);

    useEffect(() => {

        if (variantId) {
            config.API.getProduct(variantId).then((value) => {
                setProductData(value)
                setUserManualData(value.user_manual);
                setSustainabilityData(value.sustainability);
                setAwards(value.awards);
                setPictures(value.image_gallery);

                //console.log(value);
            })
        }

    }, [variantId])

    const changeProductData = (name: string, data: any): void => {
        setProductData({ ...productData, [name]: data });
    };
    const changeManualData = (name: string, data: any): void => {
        setUserManualData({ ...userManualData, [name]: data });
    };
    const changeSustainabilityData = (name: string, data: any): void => {
        setSustainabilityData({ ...sustainabilityData, [name]: data });
    };


    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => {

        //Check if all pictures are valid
        let justPictures: any[] = [];
        pictures.forEach((element) => {
            if (element.image_gallery !== "") {
                justPictures.push(element.image_gallery);
            }
        });
        console.log("x ", {
            ...productData, sustainability: sustainabilityData, user_manual: userManualData, awards: awards, image_gallery: justPictures,
        })


        // Check if there is youtube link that needs to be embeded
        let dataManual = userManualData as any;
        Object.keys(userManualData).forEach((key: string) => {
            if (dataManual[key].includes('youtube')) {

                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = dataManual[key].match(regExp);

                if (match && match[2].length == 11) {
                    dataManual[key] = 'https://www.youtube.com/embed/' + match[2];
                } else {
                    // vrni error
                    notifyError("Error: Invalid youtube link. Make sure video link is enbeded.");
                    return
                }

            }
        });

        // ----------- edit product --------------
        if (variantId) {
            config.API.editProduct(ownerId, variantId, {
                ...productData, sustainability: sustainabilityData, user_manual: dataManual, awards: awards, image_gallery: justPictures, video_url: "",
            }).then((value) => {
                navigate('/products')
                notifySuccess("Updated product '" + productData.title + "'.");
            }).catch(error => {
                console.error("Error in API PUT /product/{id}: ", error);
                notifyError("Error when updating product: " + error);
            });
        }
    }

    return (<>
        <div className="company">

            <RegisterVisual title={"Edit " + productData.title + " variant"} />

            <div className="explorer">

                <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    handleSubmit(onSubmitForm)(event);
                }} >

                    <div>
                        <label> <span className="requiredMark">*</span> Product title{" "} </label>
                        <input type="text" className="issuer-form" name="title" maxLength={400} placeholder="e.g., Product 1" value={productData.title} onChange={(event) => { changeProductData("title", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Description {" "} </label>
                        <input type="text" className="issuer-form" name="description" maxLength={1000} placeholder="e.g., The product can be purchased in several colors." value={productData.description} onChange={(event) => { changeProductData("description", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <label> <span className="requiredMark">*</span> Thumbnail {" "} </label>
                        <input type="url" className="issuer-form" name="thumbnail" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={productData.thumbnail} onChange={(event) => { changeProductData("thumbnail", event.target.value); }} required ></input>
                    </div>

                    <div>
                        <h4> Image Gallery
                            {/*<input type="url" className="issuer-form" name="image_gallery" maxLength={1000} placeholder="e.g., https://www.example-gallery.com" value={productData.image_gallery } onChange={(event) => { changeProductData("image_gallery", event.target.value); }}  ></input>*/}

                            <button type="button" onClick={() => {
                                setPictures((oldPictures) => {
                                    if (oldPictures != undefined) {
                                        const newPictures = [...oldPictures];
                                        newPictures.push("");
                                        return newPictures;
                                    }
                                    return [""];

                                })
                            }} className="form_btn">Add image</button></h4>

                        {pictures != undefined && pictures.map((val, index) => {
                            return <RegisterImage key={index} data={val} onChange={(newData: any) => {
                                // update from the form in this award subsection
                                setPictures((oldPictures) => {
                                    const newPictures = [...oldPictures];
                                    newPictures[index] = newData;
                                    return newPictures;
                                })
                            }} onRemove={() => {
                                // remove this entry from awards state.
                                setPictures((oldPictures) => {
                                    const newPictures = [...oldPictures];
                                    newPictures.splice(index, 1)
                                    return newPictures;
                                })
                            }} />
                        })}
                    </div>

                    <div>
                        <label> SAP Product Code{" "} </label>
                        <input type="text" className="issuer-form" name="sap_product_code" maxLength={400} placeholder="e.g., ABC123" value={productData.sap_product_code} onChange={(event) => { changeProductData("sap_product_code", event.target.value); }} ></input>
                    </div>


                    <div>
                        <h4> Awards{" "} <button type="button" onClick={() => {
                            setAwards((oldAwards) => {
                                if (oldAwards != undefined) {
                                    const newAwards = [...oldAwards];
                                    newAwards.push({} as Award);
                                    return newAwards;
                                }
                                return [{} as Award];

                            })
                        }} className="form_btn">Add award</button></h4>

                        {awards != undefined && awards.map((val, index) => {
                            return <RegisterAward key={index} data={val} onChange={(newData: Award) => {
                                // update from the form in this award subsection
                                setAwards((oldAwards) => {
                                    const newAwards = [...oldAwards];
                                    newAwards[index] = newData;
                                    return newAwards;
                                })
                            }} onRemove={() => {
                                // remove this entry from awards state.
                                setAwards((oldAwards) => {
                                    const newAwards = [...oldAwards];
                                    newAwards.splice(index, 1)
                                    return newAwards;
                                })
                            }} />
                        })}
                    </div>

                    <div>
                        <h4> Web shop info:{" "} </h4>
                        <div>
                            <label>  Shop link{" "} </label>
                            <input type="url" className="issuer-form" name="shop_url" maxLength={1000} placeholder="e.g., https://www.example-product.com" value={productData.shop_url} onChange={(event) => { changeProductData("shop_url", event.target.value); }} ></input>
                        </div>
                    </div>

                    <div>
                        <h4> Additional product info:{" "} </h4>
                        <div>
                            <label>  Product Presentation{" "} </label>
                            <input type="url" className="issuer-form" name="product_presentation" maxLength={1000} placeholder="e.g., https://www.example-product.com" value={userManualData.product_presentation} onChange={(event) => { changeManualData("product_presentation", event.target.value); }} ></input>
                        </div>

                        <div>
                            <label> Video Presentation{" "} </label>
                            <input type="url" className="issuer-form" name="video_presentation" maxLength={1000} placeholder="e.g., https://www.example-product-composition.com" value={userManualData.video_presentation} onChange={(event) => { changeManualData("video_presentation", event.target.value); }} ></input>
                        </div>

                        <div>
                            <label> User Manual{" "} </label>
                            <input type="url" className="issuer-form" name="user_manual" maxLength={1000} placeholder="e.g., https://www.example-steps.com" value={userManualData.user_manual} onChange={(event) => { changeManualData("user_manual", event.target.value); }} ></input>
                        </div>

                        {/*<div>
                            <label> Cleaning Instructions{" "} </label>
                            <input type="url" className="issuer-form" name="cleaning_instructions " maxLength={1000} placeholder="e.g., https://www.example-instructions.com" value={userManualData.cleaning_instructions  } onChange={(event) => { changeManualData("cleaning_instructions", event.target.value); }} ></input>
                        </div>*/}
                    </div>

                    <div>
                        <h4> Sustainability{" "} </h4>
                        <div>
                            <label> Recycled/biobased material share{" "} </label>
                            <input type="text" className="issuer-form" name="recycled_biobased_material_share" maxLength={1000} placeholder="e.g., Low" value={sustainabilityData.recycled_biobased_material_share} onChange={(event) => { changeSustainabilityData("recycled_biobased_material_share", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Energy source in production{" "} </label>
                            <input type="text" className="issuer-form" name="energy_source_in_production" maxLength={1000} placeholder="e.g., 25%" value={sustainabilityData.energy_source_in_production} onChange={(event) => { changeSustainabilityData("energy_source_in_production", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Recyclability{" "} </label>
                            <input type="text" className="issuer-form" name="recyclability" maxLength={1000} placeholder="e.g., 15%" value={sustainabilityData.recyclability} onChange={(event) => { changeSustainabilityData("recyclability", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label>  Compliance with Standards{" "} </label>
                            <input type="text" className="issuer-form" name="compliance_with_standards" maxLength={1000} placeholder="e.g., 90%" value={sustainabilityData.compliance_with_standards} onChange={(event) => { changeSustainabilityData("compliance_with_standards", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> Carbon footprint{" "} </label>
                            <input type="text" className="issuer-form" name="carbon_footprint" maxLength={1000} placeholder="e.g., Material type" value={sustainabilityData.carbon_footprint} onChange={(event) => { changeSustainabilityData("carbon_footprint", event.target.value); }}  ></input>
                        </div>
                        <div>
                            <label> Carbon footprint reduction due to renewable energy{" "} </label>
                            <input type="text" className="issuer-form" name="carbon_footprint_reduction_renewables" maxLength={1000} placeholder="e.g., https://www.example-recycling.com" value={sustainabilityData.carbon_footprint_reduction_renewables} onChange={(event) => { changeSustainabilityData("carbon_footprint_reduction_renewables", event.target.value); }}  ></input>
                        </div>
                    </div>

                    <button className="btn btn-primary" type="submit"> {'Save changes'}</button>
                    <button className="btn btn-secondary" onClick={() => {
                        navigate('/products');
                    }} > Back</button>
                </form>

            </div>

            <Footer />
        </div>
    </>)
}

export default EditVariant;
